export const isValidNumber = (
  value: null | number | string | undefined
): value is number =>
  value !== undefined &&
  value !== null &&
  !Number.isNaN(Number(value)) &&
  value !== ''

export const formatCurrency = (value: number) =>
  new Intl.NumberFormat('en-CA', {
    currency: 'CAD',
    maximumFractionDigits: 2,
    style: 'currency',
  }).format(value)

export const formatNumber = (value: number) =>
  new Intl.NumberFormat('en-CA').format(value)
